jQuery(document).ready(function ($) {
    const $testimonialSlider = $('#testimonial-slider');
    const $contentSlider = $('#content-slider');

    if ($('#testimonial-slider .slide').length > 1) {
        // Initialize region testimonial carousel
        $testimonialSlider.slick({
            autoplay: false,
            autoplaySpeed: 7000,
            infinite: false,
            dots: false,
            arrows: true,
            fade: false,
            prevArrow:
                "<button type='button' class='slick-prev'><i class='fa fa-chevron-left'></i></button>",
            nextArrow:
                "<button type='button' class='slick-next'><i class='fa fa-chevron-right'></i></button>",
            appendArrows: '.block-testimonial-slider #arrows',
            // responsive: [
            //     {
            //         breakpoint: 992,
            //         settings: {
            //             arrows: true,
            //             dots: false,
            //         },
            //     },
            // ],
        });
    }

    if ($('#content-slider .slide').length > 1) {
        // Initialize region content carousel
        $contentSlider.slick({
            autoplay: false,
            autoplaySpeed: 7000,
            infinite: false,
            dots: true,
            arrows: true,
            fade: false,
            prevArrow:
                "<button type='button' class='slick-prev'><i class='fa fa-chevron-left'></i></button>",
            nextArrow:
                "<button type='button' class='slick-next'><i class='fa fa-chevron-right'></i></button>",
            appendArrows: '.block-content-slider .slider-nav',
            appendDots: '.block-content-slider .slider-nav',
            // responsive: [
            //     {
            //         breakpoint: 992,
            //         settings: {
            //             arrows: true,
            //             dots: false,
            //         },
            //     },
            // ],
        });
    }
});



// WEBPACK FOOTER //
// ./src/js/slider-controller.js